import styled from 'styled-components';

export const HttpsText = styled.div`
  font-size: 16px;
  color: ${props => props.theme.interface5};
  line-height: 24px;
`;
